import { Form, FormProps, message } from "antd";
import api from "common/api";
import { IPrograms } from "common/types/programs";
import dayjs from "dayjs";
import { FieldData } from "rc-field-form/es/interface";
import React, { FC, createContext, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Context = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const onFinish: FormProps["onFinish"] = async (values) => {
    try {
      const payload = {
        ...values,
        gallery:
          values?.gallery?.map((item: any) => item?.response?.data) || [],
        rankings: values?.rankings || [],
      };
      const response = await api.programs.addProgram(payload, id);
      message.success(id ? "Dastur yangilandi" : "Dastur yaratildi");
      navigate(-1);
    } catch (err) {
      console.log(err);
    }
  };

  const getById = async (id: string) => {
    try {
      const response = await api.programs.getById(id);
      const fields: FieldData[] = (
        Object.keys(response.data) as (keyof IPrograms)[]
      ).map((key) => ({
        name: key,
        value:
          key === "admission_deadline"
            ? dayjs(response.data[key])
            : key === "required_documents"
            ? response.data[key]?.map((doc: any) => doc._id)
            : response.data[key],
      }));
      form.setFields(fields);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async () => {
    if (id)
      try {
        const response = await api.programs.delete(id);
        message.success("Dastur o'chirildi");
        navigate(-1);
      } catch (err) {
        console.log(err);
      }
    else navigate(-1);
  };

  useEffect(() => {
    if (id) getById(id);
  }, []);

  return {
    state: { form },
    actions: { onFinish, handleDelete },
  };
};

const ProgramsAddContext = createContext<any>({ state: {}, actions: {} });

export const ProgramsAddContextProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const value = Context();
  return (
    <ProgramsAddContext.Provider value={value}>
      {children}
    </ProgramsAddContext.Provider>
  );
};

export default function useProgramsAddContext() {
  return useContext<ReturnType<typeof Context>>(ProgramsAddContext);
}
